import { apiClient } from "@/shared/api/client";
import type {
  CreatePostingPayload,
  Posting,
  Shift,
  ShiftFilters,
  ShiftListResponse,
  ShiftStatus,
  UpdateShiftPayload,
} from "@/features/shifts/types";

export async function listOpenShifts(filters: ShiftFilters = {}): Promise<ShiftListResponse> {
  const { data } = await apiClient.get<ShiftListResponse>("/shifts", { params: filters });
  return data;
}

export async function listMyVenueShifts(status?: ShiftStatus): Promise<ShiftListResponse> {
  const { data } = await apiClient.get<ShiftListResponse>("/shifts/mine", {
    params: status ? { status } : {},
  });
  return data;
}

export async function getShift(id: string): Promise<Shift> {
  const { data } = await apiClient.get<Shift>(`/shifts/${id}`);
  return data;
}

export async function createPosting(payload: CreatePostingPayload): Promise<Posting> {
  const { data } = await apiClient.post<Posting>("/postings", payload);
  return data;
}

export async function updateShift(id: string, payload: UpdateShiftPayload): Promise<Shift> {
  const { data } = await apiClient.put<Shift>(`/shifts/${id}`, payload);
  return data;
}

export async function cancelShift(id: string): Promise<Shift> {
  const { data } = await apiClient.delete<Shift>(`/shifts/${id}`);
  return data;
}
